import React from "react";
import "./../../App.css";
import { Container, Nav, Navbar } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // Import default skeleton styles
import "./skelton.css";
import LogoSkelton from "./../../assets/skelton-img/LogoSkelton.png";
import TnspCard from "../../components/skeltons/TnspCard";
import TnspCardSecond from "../../components/skeltons/TnspCardSecond";

const LandingSkeleton = () => {
  return (
    <>
      <div className="Navbar-main-container ">
        <Navbar
          collapseOnSelect
          expand="lg"
          className="w-100 navbar first-navbar"
        >
          <Container className="w-100 px-0">
            {/* Logo Skeleton */}
            <Navbar.Brand href="/" className="nav-logo navbar-logo">
              <img src={LogoSkelton} alt="" />
            </Navbar.Brand>

            {/* Navigation Skeleton */}
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="me-auto d-flex align-items-center gap-3">
                {[0, 1, 2, 3, 4].map((index) => (
                  <Skeleton
                    key={`landing-navbar-skel-${index}`}
                    height={15}
                    width={100}
                    className="custom-skeleton"
                    style={{
                      marginRight: "10px",
                      borderRadius: "10px",
                      backgroundColor: " rgba(255, 255, 255, 0.10)",
                    }}
                  />
                ))}
              </Nav>

              {/* Button Skeleton */}
              <Nav>
                <Skeleton
                  height={40}
                  width={149}
                  className="custom-skeleton-button"
                  style={{
                    borderRadius: "20px",
                    backgroundColor: "#07BE72",
                  }}
                />
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        {/* for mobile */}
        <div className="mobile-navbar">
          <div className="d-flex justify-content-between align-items-center">
            <div className="mobile-icon">
              <Skeleton
                width={"28px"}
                height={"28px"}
                className="custom-skeleton"
                style={{
                  backgroundColor: "#07BE72",
                }}
              />
            </div>
            <div className="pt-1 pb-2">
              <Skeleton
                width={"100px"}
                height={"30px"}
                className="custom-skeleton"
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.10)",
                }}
              />
            </div>
            <div className="mobile-icon ">
              <Skeleton
                width={"36px"}
                height={"36px"}
                className="custom-skeleton"
                style={{
                  borderRadius: "80px",

                  backgroundColor: "rgba(255, 255, 255, 0.10)",
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="conatiner " style={{ paddingLeft: "16px", paddingRight: "16px", overflow: "hidden" }}>
        <div className="hero-section">
          <div className="hero-main">
            <Skeleton
              width={"100%"}
              height={"56px"}
              className="custom-skeleton"
              style={{
                borderRadius: "80px",
                marginBottom: "46px",
                backgroundColor: "rgba(255, 255, 255, 0.20)",
              }}
            />
            {["453px", "434px", "413px"].map((width) => (
              <Skeleton
                key={`landing-hero-line-${width}`}
                width={width}
                height={"16px"}
                className="custom-skeleton skelton-width-ctrl"
                style={{
                  borderRadius: "80px",
                  margin: "0px",
                  backgroundColor: "rgba(255, 255, 255, 0.10)",
                }}
              />
            ))}

            <div className="custom-skeleton-button"></div>

            <Skeleton
              width={"179px"}
              height={"48px"}
              className="custom-skeleton-button"
              style={{
                borderRadius: "80px",
                marginTop: "48px",
                backgroundColor: "#07BE72",
              }}
            />
          </div>
          <div className="hero-main-bottom">
            <TnspCard />
            <TnspCard />
            <TnspCard />

            <TnspCardSecond />
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingSkeleton;
